import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import Layout from "@/router/layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import EcGrid from "@/components/widgets/EcGrid.vue";
import formListingMachine from "./machines/FormsListingMachine";
import { interpret } from "xstate";
import FormComponent from "./components/FormComponent.vue";
import DeleteComponent from "@/components/deleteComponent.vue";
import { PAFormSearchModel } from "@/store/models/paForm/paFormSearchData";
import { FormModule } from "@/store/modules/paForm.module";
let FormListing = /** @class */ (() => {
    let FormListing = class FormListing extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.title = "Forms";
            this.gridUILoading = false;
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Performance",
                    href: "#",
                },
                {
                    text: "Forms",
                    active: true,
                },
            ];
            this.initialPage = 1;
            this.initialPageSize = 10;
            this.searchData = new PAFormSearchModel();
            this.columns = [
                {
                    field: "formName",
                    label: "Form Name",
                    thClass: "form-name-header",
                    filterOptions: {
                        enabled: true,
                        placeholder: "Search Form",
                        autoComplete: "off",
                    },
                },
                {
                    field: "questionsCount",
                    label: "No.of Questions",
                    thClass: "form-count-header",
                    sortable: false,
                },
                {
                    field: "status",
                    label: "Status",
                    filterOptions: {
                        enabled: true,
                        filterDropdownItems: [],
                    },
                    sortable: false,
                },
                {
                    field: "actions",
                    label: "Actions",
                    thClass: "form-status-header",
                    sortable: false,
                },
            ];
            this.serverParams = {
                columnFilters: {},
                sort: {
                    field: "formName",
                    type: "none",
                },
                page: 1,
                pageSize: 10,
            };
            this.totalCount = 0;
            //   MACHINE
            this.machine = formListingMachine;
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
        }
        send(event) {
            this.machineService.send(event);
        }
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        }
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.loadItems();
        }
        onPerPageChange(params) {
            this.updateParams({
                pageSize: params.currentPerPage,
                page: this.initialPage,
            });
            this.loadItems();
        }
        onSortChange(params) {
            this.updateParams({ sort: params[0], page: this.initialPage });
            this.loadItems();
        }
        onColumnFilter(params) {
            this.updateParams({
                columnFilters: params.columnFilters,
                page: this.initialPage,
            });
            this.loadItems();
        }
        loadItems() {
            this.gridUILoading = true;
            var filters = [];
            Object.entries(this.serverParams.columnFilters).forEach(([key, value]) => {
                filters.push({
                    name: key,
                    value: value,
                });
            });
            var searchData = {
                page: this.serverParams.page,
                pageSize: this.serverParams.pageSize,
                sort: this.serverParams.sort,
                columnFilters: filters,
            };
            FormModule.AssignSearchParams(searchData);
            this.machineService.send({ type: "GETTING_FORMS", searchData: searchData });
        }
        get rows() {
            return FormModule.forms;
        }
        get stauts() {
            return FormModule.status.map((x) => x.code);
        }
        get totalForms() {
            return FormModule.totalCount;
        }
        archiveForm(id) {
            let isPageChanged = this.isAnyFilterApplied && this.rows.length === 1 && this.serverParams.page !== 1;
            this.machineService.send({ type: "ARCHIVE_FORM", formId: id, isArchived: true, ispageChanged: isPageChanged });
        }
        unArchiveForm(id) {
            let isPageChanged = this.isAnyFilterApplied && this.rows.length === 1 && this.serverParams.page !== 1;
            this.machineService.send({ type: "ARCHIVE_FORM", formId: id, isArchived: false, ispageChanged: isPageChanged });
        }
        showAddModal() {
            this.showForm("Add");
        }
        duplicateForm(id) {
            this.machineService.send({ type: "DUPLICATE_FORM", formId: id });
        }
        editForm(formId) {
            this.formId = formId;
            this.showForm("Edit");
        }
        viewForm(params) {
            this.formId = params.row.id;
            this.showForm("View");
        }
        showForm(mode) {
            let formComponent = this.$refs["formComponentRef"];
            formComponent.showModal(mode, this.formId);
        }
        showdeleteFormModal(formId) {
            const isPageChanged = this.rows.length == 1 && this.serverParams.page != 1 ? true : false;
            this.formId = formId;
            this.machineService.send({ type: "DELETE_FORM", ispageChanged: isPageChanged });
        }
        clearFilter() {
            this.serverParams.columnFilters = {};
            var ecgrid = this.$refs.ecgrid;
            ecgrid.$refs.grid.$refs["table-header-primary"].$refs["filter-row"].columnFilters = {};
            this.loadItems();
        }
        setInitial() {
            this.serverParams.columnFilters.formName = "";
            this.serverParams.columnFilters.status = "";
            this.serverParams.page = this.gridParams.page;
            this.serverParams.pageSize = this.gridParams.pageSize;
            this.loadItems();
        }
        RefreshPage() {
            this.setInitial();
        }
        deleteForm() {
            this.machineService.send({ type: "DELETING_FORM", formId: this.formId });
        }
        get isAnyFilterApplied() {
            return this.columnFilters.length != 0 && this.columnFilters.some((x) => x.value);
        }
        get columnFilters() {
            var filters = [];
            Object.entries(this.serverParams.columnFilters).forEach(([key, value]) => {
                filters.push({
                    name: key,
                    value: value,
                });
            });
            return filters;
        }
        get gridParams() {
            return FormModule.searchParams;
        }
        created() {
            this.machineService.start();
            this.machineService.onTransition((state) => {
                var previousState = this.state;
                this.state = state;
                if (this.state.matches("loadedForms")) {
                    this.totalCount = this.totalForms;
                    this.gridUILoading = false;
                    this.formId = "";
                    var itemTypeColumn = this.columns.find((x) => x.field == "status");
                    if (itemTypeColumn && itemTypeColumn.filterOptions.filterDropdownItems.length == 0) {
                        itemTypeColumn.filterOptions.filterDropdownItems = this.stauts;
                    }
                }
                if (this.state.matches("gettingForms") || this.state.matches("archivingForm")) {
                    this.gridUILoading = true;
                }
                if ((this.state.matches("gettingForms") && previousState.matches("deletingForm")) || (this.state.matches("gettingForms") && previousState.matches("archivingForm"))) {
                    if (this.state.context.ispageChanged) {
                        this.serverParams.page = this.serverParams.page - 1;
                    }
                }
            });
        }
        destroyed() {
            this.machineService.stop();
        }
    };
    FormListing = __decorate([
        Component({
            name: "FormListing",
            components: {
                Layout,
                PageHeader,
                Loader,
                EcGrid,
                FormComponent,
                DeleteComponent,
            },
        })
    ], FormListing);
    return FormListing;
})();
export default FormListing;
